/**
 * @generated SignedSource<<17166ac3176597247d0c8db4c496d6d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type StorecastDeviceInputMode = "SIGNAGE" | "TOUCH";
import { FragmentRefs } from "relay-runtime";
export type StorecastHeaderTV_storecast$data = {
  readonly dashboard: {
    readonly id: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"TVDashboardPickerButton_dashboard">;
  };
  readonly inputMode: StorecastDeviceInputMode | null;
  readonly name: string;
  readonly store: {
    readonly dashboards: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"TVDashboardPickerButton_dashboards">;
    }>;
    readonly name: string;
  } | null;
  readonly " $fragmentType": "StorecastHeaderTV_storecast";
};
export type StorecastHeaderTV_storecast$key = {
  readonly " $data"?: StorecastHeaderTV_storecast$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorecastHeaderTV_storecast">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "dashboardId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorecastHeaderTV_storecast",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "inputMode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "store",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Dashboard",
          "kind": "LinkedField",
          "name": "dashboards",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TVDashboardPickerButton_dashboards"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "dashboardId",
            "variableName": "dashboardId"
          }
        ],
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TVDashboardPickerButton_dashboard"
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "StorecastScreen",
  "abstractKey": null
};
})();

(node as any).hash = "e7efec61e892b1c42c51b7ff0d5fd667";

export default node;
